<template>
  <div>
    <div>
      <div class="input-box">
        <input
          type="text"
          placeholder="请输入手机号"
          v-model="phone"
          @input="phoneLoginInput"
          class="loginInput"
        />
      </div>

      <Drag class="drag-wrap" @confirmSuccess="confirmSuccess" />
      <div class="code-wrap input-box">
        <input
          type="number"
          v-model="paw"
          :placeholder="placeholderpaw"
          @input="phoneLoginInput"
          class="loginInput"
          v-if="codeBtn"
        />
        <input
          type="password"
          v-model="paw"
          :placeholder="placeholderpaw"
          @input="phoneLoginInput"
          class="loginInput"
          v-if="!codeBtn"
        />
        <button @click="getCode" :disabled="codeFlag" v-if="codeBtn">{{phoneCode}}</button>
      </div>
      <button
        class="login-btn"
        :class="{'show-btn':!phoneBthShow}"
        :disabled="phoneBthShow"
        @click="clickBtn"
      >{{loginBtn}}</button>
    </div>
    <div style="display:flex" v-if="serviceFlag">
      <van-checkbox v-model="checked" checked-color="#ff9900" @change="changeChecked">
        <p class="terms">我已看过并同意</p>
      </van-checkbox>
      <i class="service" @click="showPopup">《服务条款》</i>
    </div>
    <!-- 服务条款 -->
    <van-popup v-model="termsShow" :style="{ height: '80%',width:'80%',background:'#fff' }">
      <Terms />
    </van-popup>
  </div>
</template>

<script>
import Drag from "../components/Drag";
import Terms from '../components/Terms'
import { smsCode } from "../request/api";
export default {
  data() {
    return {
      phoneCode: "获取验证码",
      codeFlag: false,
      phoneBthShow: true,
      phone: "",
      paw: "",
      dragSuccess: false,
      checked: "",
      serviceCheck: false,
      termsShow: false //服务条款
    };
  },
  props: {
    placeholderpaw: String,
    codeBtn: Boolean,
    loginBtn: String,
    serviceFlag: Boolean
  },
  components: {
    Drag,
    Terms
  },
  methods: {
    confirmSuccess(e) {
      this.dragSuccess = e;
    },
    showPopup() {
      this.termsShow = true;
    },
    clickBtn() {
      let obj = {
        dragSuccess: this.dragSuccess,
        serviceCheck: this.serviceCheck,
        phone: this.phone,
        paw: this.paw
      };
      this.$emit("clickBtn", obj);
    },
    //手机登录验证
    phoneLoginInput() {
      let phone = this.phone.trim();
      let paw = this.paw.trim();
      if (phone && paw) {
        this.phoneBthShow = false;
      } else if (phone.length < 1 || paw.length < 1) {
        this.phoneBthShow = true;
      }
    },
    //获取验证码
    getCode() {
      let phone = this.phone;
      let myreg = /^13[\d]{9}$|^14[5,7]{1}\d{8}$|^15[^4]{1}\d{8}$|^17[0,3,6,7,8]{1}\d{8}$|^18[\d]{9}$/;
      if (phone.length < 1) {
        this.$toast("请输入手机号");
        return;
      } else if (!myreg.test(phone)) {
        this.$toast("请输入正确的手机号");
        return;
      }
      //倒计时
      let time = null;
      let num = 60;
      smsCode(phone).then(res => {
        if (res.status == 200) {
          time = setInterval(() => {
            if (num > 1) {
              num--;
              this.phoneCode = `重新发送${num}`;
              this.codeFlag = true;
            } else {
              this.phoneCode = "获取验证码";
              this.codeFlag = false;
              clearInterval(time);
            }
          }, 1000);
        } else {
          this.$toast(res.msg);
        }
      });
    },
    //服务条款勾选状态
    changeChecked(e) {
      this.serviceCheck = e;
    }
  }
};
</script>

<style lang="less" scoped>
.loginInput {
  width: 58%;
  padding-bottom: 40px;
  display: inline-block;
}
.drag-wrap {
  margin: 65px 0;
}
.login-btn {
  width: 100%;
  height: 90px;
  color: #fff;
  font-size: 36px;
  border: none;
  background: #ffcc7f;
  border-radius: 10px;
  margin: 30px 0 50px 0;
}
.show-btn {
  background: #ff9900;
}
.login-type {
  font-size: 27px;
  color: #666;
}
.input-box {
  border-bottom: 1px solid #e5e5e5;
}
.code-wrap {
  position: relative;
  button {
    width: 200px;
    height: 60px;
    border: 1px solid #e5e5e5;
    font-size: 26px;
    border-radius: 5px;
    background: #fff;
    position: absolute;
    right: 0;
  }
}
.terms {
  font-size: 28px;
}
.service {
  color: #ff9900;
  font-size: 28px;
  margin-top: 9px;
}

</style>